import api from "@/shared/api.jsx";
import { logError, logInfo } from "@/shared/utils/logger.js";

export async function askDataCopilot(question) {
  try {
    const response = await api.post("/data-copilot/query", { question });
    const data = response.data || response;

    logInfo("Data Copilot question answered", {
      source: data?.meta?.source || null,
      hasVisualization: Boolean(data?.visualization),
    });

    return {
      success: true,
      data,
    };
  } catch (error) {
    logError("Failed to ask Data Copilot", {
      error: error.message,
    });

    return {
      success: false,
      error: error.message || "Failed to ask Data Copilot",
    };
  }
}

export async function getDataCopilotHealth() {
  try {
    const response = await api.get("/data-copilot/health");
    return {
      success: true,
      data: response.data || response,
    };
  } catch (error) {
    logError("Failed to fetch Data Copilot health", {
      error: error.message,
    });

    return {
      success: false,
      error: error.message || "Failed to fetch Data Copilot health",
    };
  }
}
